import React, { useRef, useState } from "react";
// import { connect } from "react-redux";
import {
  GridToolbarContainer,
  GridToolbarQuickFilter,
  GridPagination,
  GridToolbarColumnsButton,
} from "@mui/x-data-grid";
import CreateRow from "./CreateRow";
import DownloadExcel from "../../App/validation/DownloadExcel";
import { MoreVert } from "@material-ui/icons";
import FLOAT_MENU from "../common_trivial/FLOAT_MENU";
import useLanguage from "../common_hooks/useLanguage";

// solusi sementara pakai functional component
function CustomToolbarContainer(props) {
  const [anchor, set_anchor] = useState(null);
  const [modal_more_button, set_modal_more_button] = useState(false);

  const { dict, language } = useLanguage();

  const childRef = useRef(null);

  const triggerAddRowClicked = () => {
    childRef.current.handleAddRowClicked();
    toggle_modal_more_button();
  };

  const toggle_modal_more_button = (e) => {
    set_anchor(e?.currentTarget);
    set_modal_more_button(!modal_more_button);
  }

  const modal_more_button_content = <FLOAT_MENU
    id="basic-menu"
    anchorEl={anchor}
    open={modal_more_button}
    onClose={toggle_modal_more_button}
    MenuListProps={{
      "aria-labelledby": "basic-button",
    }}
    style={{ borderRadius: "15px" }}
  >
    <div style={{ display: "flex", flexDirection: "column" }}>
      <div className="button_big button_white outline_shadow_soft margin_bottom">
        <button
          onClick={triggerAddRowClicked}
          style={{
            display: "flex",
            alignItems: "center",
            gap: "5px",
            textTransform: "uppercase",
          }}
        >
          <span
            style={{
              fontWeight: "500",
              fontSize: "25px",
              marginTop: "-5px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            +
          </span>
          {dict?.["Add Row"]?.[language]}
        </button>
        {/* <CreateRow {...props} /> */}
      </div>
      <div className="button_big button_white outline_shadow_soft margin_bottom">
        <GridToolbarColumnsButton />
      </div>
      <div className="button_big button_white outline_shadow_soft">
        <DownloadExcel />
      </div>
    </div>
  </FLOAT_MENU>

  return (
    <GridToolbarContainer>
      <div className="row_table">
        <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
          <GridToolbarQuickFilter />
        </div>
        <div className="flex">
          <GridPagination />
          <button className="button_big button_white center_perfect" onClick={toggle_modal_more_button}>
            <MoreVert />
          </button>
        </div>
      </div>
      <CreateRow ref={childRef} {...props} />
      {modal_more_button_content}
    </GridToolbarContainer>
  );
}

export default CustomToolbarContainer;
